'use strict';

var WorkflowSettingsDirective = function WorkflowSettingsDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/workflow-settings-panel.html'),
    controller: 'WorkflowSettingsController',
    scope: {
      user: '=?',
      isSystemDefault: '=?',
      isOwnProfile: '=?',
      backToUserList: '=?'
    },
    link: function link($scope) {
      $scope.initialize();
    }
  };
};
WorkflowSettingsDirective.$inject = [];
module.exports = WorkflowSettingsDirective;